import { market } from '../constants';

export const balanceSelector = (innerBalance, cardNumber) => {
  const balance = innerBalance.filter(
    (balance) => balance.nroTarjeta === cardNumber,
  );
  return balance[0]?.montoInicial || '';
};

export const showPointsInSideBar = () => market !== 'pe';

export const thousandsFormatter = (number) =>
  new Intl.NumberFormat().format(number);
